import { resolveShellPostMessageTarget } from '@/bridge/shellOrigin';
import { SandboxMessageType, type SandboxSyncedMessage } from '@web-studio/shared-schemas';

export function postSandboxSyncedToShell(
  blockCount: number,
  activePageId: string | null,
): void {
  if (typeof window === 'undefined' || window.parent === window || blockCount === 0) {
    return;
  }

  const message: SandboxSyncedMessage = {
    type: SandboxMessageType.SANDBOX_SYNCED,
    blockCount,
    activePageId,
  };
  window.parent.postMessage(message, resolveShellPostMessageTarget());
}
